import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Chip } from '@mui/material';
import FilterBar from './FilterBar';

const platformStyle = (p) => {
  if (p === 'zerodha') return { bgcolor: '#fef3c7', color: '#92400e' };
  if (p === 'shoonya') return { bgcolor: '#ede9fe', color: '#5b21b6' };
  return { bgcolor: '#f1f5f9', color: '#475569' };
};
const platformLabel = (p) =>
  p === 'zerodha' ? 'Zerodha' : p === 'shoonya' ? 'Shoonya' : p || 'N/A';

const OrderResponsesTable = ({ orderResponses }) => {
  const [filters, setFilters] = useState([]);

  const filterOptions = {
    user:     [...new Set(orderResponses.map(r => r.user))].filter(Boolean),
    platform: [...new Set(orderResponses.map(r => r.platform))].filter(Boolean),
    response: [...new Set(orderResponses.map(r => r.response))].filter(Boolean),
  };

  const columnLabels = {
    user:     'User',
    platform: 'Platform',
    response: 'Response',
  };

  const addFilter    = (col, val) => setFilters(prev => [...prev.filter(f => f.column !== col), { column: col, value: val }]);
  const removeFilter = (col)      => setFilters(prev => prev.filter(f => f.column !== col));
  const clearFilters = ()         => setFilters([]);

  const filtered = orderResponses.filter(r =>
    filters.every(f => {
      if (f.column === 'user')     return r.user === f.value;
      if (f.column === 'platform') return r.platform === f.value;
      if (f.column === 'response') return r.response === f.value;
      return true;
    })
  );

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <FilterBar
        filters={filters}
        filterOptions={filterOptions}
        columnLabels={columnLabels}
        onAdd={addFilter}
        onRemove={removeFilter}
        onClear={clearFilters}
      />
      <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Platform</TableCell>
              <TableCell>Symbol</TableCell>
              <TableCell>Response</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered.map((r, i) => (
              <TableRow key={i}>
                <TableCell sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>{r.user}</TableCell>
                <TableCell>
                  <Chip label={platformLabel(r.platform)} size="small"
                    sx={{ ...platformStyle(r.platform), fontWeight: 600, fontSize: '0.68rem', height: 20 }} />
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{r.tradingsymbol}</TableCell>
                <TableCell sx={{ fontSize: '0.775rem', color: 'text.secondary', maxWidth: 500, wordBreak: 'break-word' }}>
                  {r.response}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OrderResponsesTable;
